import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class PlushieUpgradeRelation implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;

  constructor(
    private fId: string,
    private fPlushie: string,
    private fUpgrade: string
  ) {
    [fId, fPlushie, fUpgrade].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id() {
    return this.fId;
  }

  get createdAt() {
    return this.fCreatedAt;
  }

  get plushie() {
    return this.fPlushie;
  }

  get upgrade() {
    return this.fUpgrade;
  }
}
